import React from "react";
import { Jumbotron } from "reactstrap";

/**
 * No data component
 */
export default () => (
  <Jumbotron>
    <h1 className="display-3">No artists found.</h1>
  </Jumbotron>
);
